import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import orderStatisticService from "services/orderStatistic";

export const useCountOrderByHub = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["orderStatistic"]);
  const { addToast } = useToasts();
  const { params, key, enabled } = payload;

  return useQuery(
    ["count-order-by-hub", key || ""],
    () => orderStatisticService.countOrderByHub({ params }),
    {
      enabled: enabled || false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message || t("message.get_hub_list_error"),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        return response?.data;
      },
    }
  );
};

export const useCountOrderByRunner = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["orderStatistic"]);
  const { addToast } = useToasts();
  const { params, key, enabled } = payload;

  return useQuery(
    ["count-order-by-runner", key || "", params],
    () => orderStatisticService.countOrderByRunner({ params }),
    {
      enabled: enabled || false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message || t("message.get_hub_list_error"),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        return response?.data;
      },
    }
  );
};
